export enum AppDesignerMode {
    /** Designing UI for Mobile Applications */
    APP_DESIGN = "appDesign",
    /** Adjusting Web Designs for Mobile Application Compatibility */
    APP_COMPAT = "appCompatibility"
}
